import { Box, Typography } from '@mui/material';
import React from 'react';

import PendingIcon from '@/assets/icons/steps-pending.svg?react';

interface Props {
  readonly label: string;
  readonly status: 'pending';
}

export const TransactionDetailsDrawerStatusPlaceholderItem: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { label } = props;

  return (
    <Box display="flex" flexDirection="column" alignItems="top" position="relative">
      <Box display="flex" alignItems="center" gap={2}>
        <Box color="text.primary" height={16}>
          <PendingIcon stroke="currentColor" />
        </Box>
        <Typography variant="body2" color="custom.Inactive">
          {label}
        </Typography>
      </Box>
    </Box>
  );
};
